import { useCallback } from 'react';
import { kinderConnectCaptureSettingsFormValuesValidator } from './kinder-connect-capture-settings-form-values-validator';
export const useKinderConnectCaptureSettingsFormValuesValidator = (_formValues) => {
    return useCallback((variables) => kinderConnectCaptureSettingsFormValuesValidator(variables), []);
};
